import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./passwordchecker.css";

const PasswordChecker = ({ password, confirmPassword, readyHandler }) => {
  // Break down the regex into individual requirements for granular feedback
  const requirements = [
    { id: 1, label: "At least 8 characters", test: (p) => p.length >= 8 },
    {
      id: 2,
      label: "Contains a lowercase letter",
      test: (p) => /[a-z]/.test(p),
    },
    {
      id: 3,
      label: "Contains an uppercase letter",
      test: (p) => /[A-Z]/.test(p),
    },
    { id: 4, label: "Contains a number", test: (p) => /\d/.test(p) },
    {
      id: 5,
      label: "Contains a special char (@$!%*?&)",
      test: (p) => /[@$!%*?&]/.test(p),
    },
  ];

  const [matches, setMatches] = useState(false);
  const [allRequirementsMet, setAllRequirementsMet] = useState(false);

  useEffect(() => {
    // Check if passwords match
    const doPasswordsMatch =
      password === confirmPassword && password.length > 0;
    setMatches(doPasswordsMatch);

    // Check if all regex requirements are passed
    const allMet = requirements.every((req) => req.test(password));
    setAllRequirementsMet(allMet);

    // Send ready state back to parent
    if (doPasswordsMatch && allMet) {
      readyHandler(true);
    } else {
      readyHandler(false);
    }
  }, [password, confirmPassword, requirements, readyHandler]);

  return (
    <>
      <ul className="requirement-list">
        {requirements.map((req) => {
          const isValid = req.test(password);
          return (
            <li
              key={req.id}
              className={`req-item ${isValid ? "valid" : "invalid"}`}
            >
              <span className="icon-wrapper">
                <FontAwesomeIcon
                  icon={isValid ? faCircleCheck : faCircle}
                  className="req-icon"
                />
              </span>
              <span>{req.label}</span>
            </li>
          );
        })}
        <li className={`req-item ${matches ? "valid" : "invalid"}`}>
          <span className="icon-wrapper">
            <FontAwesomeIcon
              icon={matches ? faCircleCheck : faTimesCircle}
              className="req-icon"
            />
          </span>
          <span>Passwords Match</span>
        </li>
      </ul>
    </>
  );
};

export default PasswordChecker;
